import { useEffect } from 'react';
import { useMainContext } from '@repo/app-contexts/main';
import { useGetMerchant } from '@repo/api/endpoints/merchant';

import { useMainHubStoreState, useMainHubStoreActions } from '@/store/main-hub.store';
import { VIEW_TYPE } from '@/store/view.type';

export const useRefetchMerchantOnStageChange = (isRefetchBlock?: boolean) => {
  const { currentViewType } = useMainHubStoreState();
  const { setCurrentView } = useMainHubStoreActions();
  const { hash, token } = useMainContext();
  const { refetch } = useGetMerchant({ hash, token, enabled: false });

  useEffect(() => {
    return () => {
      if (currentViewType === 'DASHBOARD' && !isRefetchBlock) {
        setCurrentView(VIEW_TYPE.APP_LOADING);
        void refetch().then(() => {
          setCurrentView(VIEW_TYPE.DASHBOARD);
        });
      }
    };
  }, []);
};
